"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabPanel = exports.TabsPanels = exports.TabHeader = exports.tabsHeaders = exports.tabHeaderWrapper = exports.TabsWrapper = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _core = require("@emotion/core");

var _eyemobileCore = _interopRequireDefault(require("@bit/eyemobile.core.constants"));

var _facepaint = _interopRequireDefault(require("facepaint"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var mq = (0, _facepaint["default"])(['@media screen and (min-width: 375px)']);
var TabsWrapper = (0, _styledBase["default"])("div", {
  target: "eekgmn90",
  label: "TabsWrapper"
})({
  name: "8atqhb",
  styles: "width:100%;"
});
exports.TabsWrapper = TabsWrapper;
var tabHeaderWrapperBps = mq({
  height: [30, 50]
});
var tabHeaderWrapper = /*#__PURE__*/(0, _core.css)(tabHeaderWrapperBps, ";width:100%;position:sticky;top:0;overflow:hidden;z-index:1000;;label:tabHeaderWrapper;");
exports.tabHeaderWrapper = tabHeaderWrapper;

var tabsHeaders = function tabsHeaders(theme) {
  return /*#__PURE__*/(0, _core.css)("width:100%;height:100%;display:flex;flex-direction:row;justify-content:flex-start;align-items:center;background-color:", theme && theme.getColor && theme.getColor('background') || '#ffffff', ";");
};

exports.tabsHeaders = tabsHeaders;

var getFontSize = function getFontSize(_ref) {
  var theme = _ref.theme;

  if (Object.prototype.hasOwnProperty.call(theme, 'getFontSize')) {
    return mq({
      fontSize: [theme.getFontSize(0.8, 'px'), theme.getFontSize(1, 'px')]
    });
  }

  return mq({
    fontSize: [12, 16]
  });
};

var TabHeader = (0, _styledBase["default"])("div", {
  target: "eekgmn91",
  label: "TabHeader"
})("height:100%;display:flex;justify-content:center;align-items:center;white-space:nowrap;text-align:center;height:40px;text-transform:uppercase;user-select:none;padding-left:", function (_ref2) {
  var theme = _ref2.theme;
  return theme && theme.getSpacing && theme.getSpacing(3, 'px') || '24px';
}, ";padding-right:", function (_ref3) {
  var theme = _ref3.theme;
  return theme && theme.getSpacing && theme.getSpacing(3, 'px') || '24px';
}, ";cursor:pointer;color:", function (_ref4) {
  var theme = _ref4.theme,
      active = _ref4.active;
  return active ? theme && theme.getColor && theme.getColor('text') || '#000000' : theme && theme.getColor && theme.getColor('default') || _eyemobileCore["default"].graytext;
}, ";border-bottom:2px solid ", function (_ref5) {
  var theme = _ref5.theme,
      active = _ref5.active;
  return active ? theme && theme.getColor && theme.getColor('primary') || '#000000' : 'transparent';
}, ";", getFontSize, ";font-weight:bold;transition:background-color,color 0.5s ease-in-out;");
exports.TabHeader = TabHeader;
var TabsPanels = (0, _styledBase["default"])("div", {
  target: "eekgmn92",
  label: "TabsPanels"
})({
  name: "byhzg3",
  styles: "width:100%;display:flex;flex-direction:column;justify-content:flex-start;"
});
exports.TabsPanels = TabsPanels;
var TabPanel = (0, _styledBase["default"])("div", {
  target: "eekgmn93",
  label: "TabPanel"
})({
  name: "8atqhb",
  styles: "width:100%;"
});
exports.TabPanel = TabPanel;

//# sourceMappingURL=Tabs.styles.js.map